module.exports = __webpack_public_path__ + "img/light-f-fm-Path 56 Copy@3x.f00b3138.png";